import React, { useEffect, useState } from "react";
import FormItem from "../../components/ui/FormItem";
import FormActions from "../ui/FormActions";

import { initialLeadData } from "../../data/intialData";

import PropTypes from "prop-types";

import { validateTwoDigitNumber } from "../../utils/validation";

const buildInitialFormData = (values = {}) => ({
  ...initialLeadData,
  ...(values || {}),
});

export default function LeadScoringForm({
  initialValues = {},
  isLoading,
  onSubmit,
}) {
  const [formData, setFormData] = useState({
    ...buildInitialFormData(initialValues),
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData(buildInitialFormData(initialValues));
    setErrors({});
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Remove non-digits
    let cleaned = value.replace(/\D/g, "").slice(0, 2);
  
    setFormData((prev) => ({
      ...prev,
      [name]: cleaned,
    }));
  
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};

    const skipValidation = ["id", "agent_id"];

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      if (skipValidation.includes(key)) return;

      if (!validateTwoDigitNumber(value)) {
        newErrors[key] = "Enter a number between 0-99";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    // ✅ payload matches backend exactly
    const payload = {
      ...formData,
    };

    onSubmit(payload);
  };

  const handleCancel = () => {
    // Reset to latest loaded values for a consistent edit experience.
    setFormData(buildInitialFormData(initialValues));
    setErrors({});
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid-auto-fit">

        {/* Budget */}
        <FormItem label="Budget Exact" name="budget_exact" value={formData.budget_exact} onChange={handleChange} error={errors.budget_exact} />
        <FormItem label="Primary Buffer" name="budget_primary_buffer" value={formData.budget_primary_buffer} onChange={handleChange} error={errors.budget_primary_buffer} />
        <FormItem label="Secondary Buffer" name="budget_secondary_buffer" value={formData.budget_secondary_buffer} onChange={handleChange} error={errors.budget_secondary_buffer} />

        {/* Contact */}
        <FormItem label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} error={errors.mobile} />
        <FormItem label="Email" name="email" value={formData.email} onChange={handleChange} error={errors.email} />

        {/* Timeline */}
        <FormItem label="Timeline (0-3 Months)" name="timeline_0_3" value={formData.timeline_0_3} onChange={handleChange} error={errors.timeline_0_3} />
        <FormItem label="Timeline (3-6 Months)" name="timeline_3_6" value={formData.timeline_3_6} onChange={handleChange} error={errors.timeline_3_6} />
        <FormItem label="Timeline (>6 Months)" name="timeline_above_6" value={formData.timeline_above_6} onChange={handleChange} error={errors.timeline_above_6} />

        {/* Funding (FIXED ✅) */}
        <FormItem label="Funding Ready" name="funding_ready" value={formData.funding_ready} onChange={handleChange} error={errors.funding_ready} />
        <FormItem label="Funding Need Loan" name="funding_need_loan" value={formData.funding_need_loan} onChange={handleChange} error={errors.funding_need_loan} />
        <FormItem label="Funding Unknown" name="funding_unknown" value={formData.funding_unknown} onChange={handleChange} error={errors.funding_unknown} />

        {/* Qualification */}
        <FormItem label="Intent" name="intent" value={formData.intent} onChange={handleChange} error={errors.intent} />

        {/* Property */}
        <FormItem label="Location" name="location" value={formData.location} onChange={handleChange} error={errors.location} />
        <FormItem label="Property Type" name="property_type" value={formData.property_type} onChange={handleChange} error={errors.property_type} />
        <FormItem label="Unit Type" name="unit_type" value={formData.unit_type} onChange={handleChange} error={errors.unit_type} />

        {/* Buyer */}
        <FormItem label="Authority" name="authority" value={formData.authority} onChange={handleChange} error={errors.authority} />
        <FormItem label="Send Detail" name="send_detail" value={formData.send_detail} onChange={handleChange} error={errors.send_detail} />
        <FormItem label="Specific Requirement" name="specific_requirement" value={formData.specific_requirement} onChange={handleChange} error={errors.specific_requirement} />
        <FormItem label="Purchase Reason" name="purchase_reason" value={formData.purchase_reason} onChange={handleChange} error={errors.purchase_reason} />

      </div>

      <FormActions
        isLoading={isLoading}
        onCancel={handleCancel}
        saveText="Save Score"
      />
    </form>
  );
}

LeadScoringForm.propTypes = {
  initialValues: PropTypes.shape({
    budget_exact: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    budget_primary_buffer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    budget_secondary_buffer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mobile: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    email: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    timeline_0_3: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    timeline_3_6: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    timeline_above_6: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    funding_ready: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    funding_need_loan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    funding_unknown: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    intent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    location: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    property_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    authority: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    send_detail: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    specific_requirement: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    purchase_reason: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),

  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};